import { render, staticRenderFns } from "./DormUser.vue?vue&type=template&id=147bdaae&"
import script from "./DormUser.vue?vue&type=script&lang=js&"
export * from "./DormUser.vue?vue&type=script&lang=js&"
import style0 from "./DormUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports